import Vue from 'vue';
import App from '~/views/App.vue';
import AppMatriz from '~/AppMatriz.vue';
//import App from '~/AppRene.vue';
import routerF from './router/';
import store from './store/';
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import Vuetify from 'vuetify'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import '@/firebase/';
import * as firebase from "firebase";
import * as VueGoogleMaps from "vue2-google-maps";
//import './registerServiceWorker'
import FlagIcon from 'vue-flag-icon';
import VStripeElements from 'v-stripe-elements/lib'
import VuetifyConfirm from 'vuetify-confirm'
import './sass/variables.scss';
import VueCookie from 'vue-cookie';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueMeta from 'vue-meta'
import VueGtag from "vue-gtag";

// For more options see below

routerF()
  .then((router) => {
    console.log(store.state);
    Vue.config.productionTip = false;
    Vue.use(VueReCaptcha, {
      siteKey: '6LfNi_gUAAAAAFjeWg6cRNArTDL-SIp-DL3opnb_',
      loaderOptions: {
        autoHideBadge: true,
      }
    })
    if (store.state.propio.negocioPropioObj
      && store.state.propio.negocioPropioObj.web
      && store.state.propio.negocioPropioObj.web.gtag) {
      Vue.use(VueGtag, {
        config: { id: store.state.propio.negocioPropioObj.web.gtag }
      });
    }

    Vue.use(Vuetify);
    Vue.use(VueMeta)
    Vue.use(FlagIcon);
    Vue.use(VStripeElements)
    Vue.use(VuetifyConfirm, { vuetify })
    Vue.use(VueCookie);
    Vue.use(VueGoogleMaps, {
      load: {
        key: "AIzaSyAFHsWe4CwUtqyYr-mf-x7TeY3GJ5fqC60",
        libraries: "places" // necessary for places input
      }
    });

    new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: (h) => h(AppMatriz)
    }).$mount('#app');
  })
  .catch((e) => {
    console.log(e);
  })




